// 使用常量替代mutation事件类型。
export const SET_INFO = 'SET_INFO';
export const SET_PER = 'SET_PER';
export const SET_ORG = 'SET_ORG';
export const SET_URL = 'SET_URL';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js